import {Component, Injector, OnInit} from '@angular/core';
import {BasePageComponent} from "@core-components/page-content/base-page.component";
import {TabManagementService} from "@core-services/tab-management.service";
import {PageEventInterface} from "@core/interfaces/page-event.interface";
import {CrudApplications} from "@features/leads/applications/applications-list/applications.model";
import {SelectableCategory} from "@features/settings/industries/industry.model";
import {ManageIndustriesService} from "@features/settings/industries/manage-industries.service";
import {DateUtilsService} from "@shared-services/dateUtils.service";
import {UtilsService} from "@shared-services/utils.service";
import {PageRequest} from "@ui-kit/framework/common/generic.service";
import {LoadingService} from "@ui-kit/framework/util/service/loading.service";
import {Retailer} from "../../retailers/retailers.model";
import {ApplicationsViewComponent} from "../applications-view/applications-view.component";
import {ApplicationsService} from "../applications.service";

@Component({
  selector: 'app-applications-list',
  templateUrl: './applications-list.component.html'
})
export class ApplicationsListComponent extends BasePageComponent implements OnInit {
  applicationsData: CrudApplications[] = [];
  offeringIndustries: SelectableCategory[] = [];

  protected readonly CrudRetailer = CrudApplications;

  constructor(injector: Injector,
              public utils: UtilsService,
              public dateUtils: DateUtilsService,
              public tabService:TabManagementService,
              private applicationsService: ApplicationsService,
              private industriesService: ManageIndustriesService,
              public loader: LoadingService) {
    super(injector);
  }

  ngOnInit() {
    this.loadIndustries();
  }

  loadRetailers() {
    const page: PageRequest = {
      size: '2000',
      page: '0',
      sort: ''
    };
    this.applicationsService.getAll('', page).subscribe({
      next: data => {
        const industriesList = this.offeringIndustries.flatMap(fm => fm.industries);
        this.applicationsData = data.content.map(m => new CrudApplications(m, industriesList));
      },
      error: error => {
        console.log(error);
      }
    })
  }

  loadIndustries() {
    this.industriesService.getAllSelectableOptionsForOffering().subscribe({
      next: data => {
        this.offeringIndustries = data;
        this.loadRetailers();
      },
      error: error => {
        console.log(error);
      }
    })
  }

  retailerSelectedForView($event: any): void {
    if ($event) {
      const selectedRetailer = ($event as Retailer);
      this.openApplicationsViewTab(selectedRetailer);
    }
  }

  openApplicationsViewTab(ret: Retailer) {
    let payload: PageEventInterface = {
      componentToRegister: ApplicationsViewComponent,
      pageName: 'Application ' + ret.id,
      pageHeader: this.offering!.label,
      data: { id: ret.id, companyName: ret.companyName },
      id: this.utils.generateUuidWithPrefix('application'),
      offeringId: this.offering!.uuid,
      sectionCode: 'leads',
      pageCode: 'applications',
      offering: this.offering
    }
    this.tabService.sendPageAddEvent(payload);
  }
}
